module.exports = __webpack_public_path__ + "img/Weapon_74.ac06c743.png";